import { useEffect, useState } from 'react'
import { gql, useMutation } from '@apollo/client'

import { getStoredApiKey } from 'lib/auth-token'
import { useTabletsBagsQuery } from 'api/queries/tablets-bags'

const SIMULATE_HIT_STREAM = gql`
  mutation simulateHitStream($bagId: String!) {
    simulateHitStream(bagId: $bagId)
  }
`

const filterDataByKey = (data: any) => {
  return data.apiKey.find((item: any) => item.key === getStoredApiKey())
}

const useDoHitStream = () => {
  const [bagId, setBagId] = useState<string>('')
  const { data } = useTabletsBagsQuery()

  const [simulateHitStream] = useMutation(SIMULATE_HIT_STREAM)

  const executeHitStream = () => {
    if (!bagId) return
    return simulateHitStream({ variables: { bagId } })
  }

  useEffect(() => {
    if (data && data.apiKey) {
      const filteredBagId = filterDataByKey(data)?.tablet[0]?.bag[0]?.id || ''
      setBagId(filteredBagId)
    }
  }, [data])

  return executeHitStream
}

export default useDoHitStream
